import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a date string for display
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * Get color class based on priority
 */
export function getPriorityColor(priority: string): string {
  const p = priority.toLowerCase()
  if (p.includes('critical') || p.includes('urgent') || p === '1') {
    return 'text-red-600 bg-red-50'
  }
  if (p.includes('high') || p === '2') {
    return 'text-orange-600 bg-orange-50'
  }
  if (p.includes('medium') || p === '3') {
    return 'text-yellow-600 bg-yellow-50'
  }
  return 'text-green-600 bg-green-50'
}

/**
 * Get color class based on status
 */
export function getStatusColor(status: string): string {
  const s = status.toLowerCase()
  if (s.includes('closed') || s.includes('resolved')) {
    return 'text-green-600 bg-green-50'
  }
  if (s.includes('pending') || s.includes('waiting')) {
    return 'text-yellow-600 bg-yellow-50'
  }
  if (s.includes('open') || s.includes('new')) {
    return 'text-blue-600 bg-blue-50'
  }
  return 'text-gray-600 bg-gray-50'
}

/**
 * Parse ticket ID from URL parameters
 */
export function getTicketIdFromUrl(): number | null {
  const params = new URLSearchParams(window.location.search)
  const ticketId = params.get('ticketId') || params.get('ticket_id') || params.get('id')
  if (ticketId) {
    const parsed = parseInt(ticketId, 10)
    if (!isNaN(parsed)) {
      return parsed
    }
  }
  return null
}
